export default {
  shippingDate: {
    id: 'sav_platform_shipping_date_new',
    defaultMessage:
      'Shipped on {shippingDate, date, short} at {shippingDate, time, short}',
  },
  estimatedDeliveryDate: {
    id: 'sav_platform_estimated_delivery_date_new',
    defaultMessage:
      'Estimated delivery between: {min, date, short} - {max, date, short}',
  },
  deliveryDate: {
    id: 'sav_platform_delivery_date_new',
    defaultMessage:
      'Delivered on {deliveryDate, date, short} at {deliveryDate, time, short}',
  },
  backshipLabel: {
    id: 'sav_platform_backship_label',
    defaultMessage: 'Backship label',
  },
  sellerLabel: {
    id: 'sav_platform_merchant_label',
    defaultMessage: 'Seller label',
  },
  carrier: {
    id: 'sav_platform_carrier_with_backship',
    defaultMessage: `Carrier: {backship, select,
          true {Backship - }
          other {}
        }{carrier}`,
  },
  trackingNumber: {
    id: 'sav_platform_tracking_number_new',
    defaultMessage: 'Tracking number: {trackingNumber}',
  },
}
